import { styled } from '@mui/system';
import { theme } from 'oems/theme';

export const Wrapper = styled('div')``;

export const Content = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Menu = styled('div')`
  position: sticky;
  top: 20px;
  background: white;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;

  .menuItem {
    button {
      width: 100%;
      padding: 0 14px;

      &:hover {
        background: ${theme.palette.background.default} !important;
      }

      .label {
        font-size: 14px;
        font-weight: 400;
        color: ${theme.palette.text.dark};
        width: 100%;
        display: flex;
        justify-content: flex-start;

        svg {
          margin-right: 12px;
          width: 26px;
          height: 26px;
        }
      }
    }
  }
`;
